import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const MZZ1 = () => (
  <ArticleWrapper articleId="mz_z1">
    <div className="prose prose-invert mx-auto p-6">
      <h1>MZ Z1</h1>
      {/* Add your MZ Z1 article content here */}
      <p>This is a placeholder article for the MZ Z1 switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default MZZ1;
